'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getCalendarMonthWidth = {};

exports.__exports = getCalendarMonthWidth;
